/**
 * If enabled, display the modal for retrieval queries
 * Product Area: SEARCH_QUERY_UNDERSTANDING_AND_RETRIEVAL
 */
export const SHOULD_DISPLAY_MODAL_QUERIES_FOR_RETRIEVAL = 'SHOULD_DISPLAY_MODAL_QUERIES_FOR_RETRIEVAL';
